import React, { useContext } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Box from '@material-ui/core/Box';
import FiltersContext from '../../contexts/FiltersContext';

function ToggleBy() {
  const { displayBy, setDisplayBy } = useContext(FiltersContext);

  const handleChange = (event) => {
    setDisplayBy(event.target.value);
  };

  return (
    <Box displayPrint="none">
      <FormControl component="fieldset">
        <FormLabel component="legend">Toggle by</FormLabel>
        <RadioGroup aria-label="toggle by" name="toggleby" value={displayBy} onChange={handleChange}>
          <FormControlLabel value="Providers" control={<Radio />} label="Number of providers" />
          <FormControlLabel value="Slots" control={<Radio />} label="Number of slots" />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}

export default ToggleBy;
